import React from 'react';
import PropTypes from 'prop-types';
import SprintDurationIcon from '../../images/durationIcon.svg';
import TeamMembersIcon from '../../images/teamMembers.svg';

const propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colDef: PropTypes.oneOfType([PropTypes.object]),
};

const defaultProps = {
  value: '',
  colDef: {},
};

const SprintMemberIcon = (props) => {
  const { value, colDef } = props;

  return value !== undefined && value !== null && value !== '' ? (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {colDef?.headerName === 'Sprints' ? (
        <img src={SprintDurationIcon} alt="Sprint-Icon" style={{ marginRight: '5px' }} />
      ) : (
        <img src={TeamMembersIcon} alt="Teammember-Icon" style={{ marginRight: '5px' }} />
      )}
      <span style={{ marginLeft: '8px' }}>{value}</span>
    </div>
  ) : null;
};

SprintMemberIcon.propTypes = propTypes;
SprintMemberIcon.defaultProps = defaultProps;
export default SprintMemberIcon;
